module.exports = __webpack_public_path__ + "img/pdf2.b3c408c2.svg";